import api, { apiSetup } from '../api';

apiSetup(undefined);

/** A Fuente: one of the Plan Maestro studies, with its Home tab label and order. */
export interface Source {
  id: number;
  name: string;
  nameEs: string;
  shortName: string;
  order: number;
}

/** The Fuentes in tab order, labels in the current language. */
export const getSources = () => api.get<Source[]>('/sources/');
